<ng-container *ngIf="!isAdmin && dataLoaded">
  <my-user-profile    
    [profileData]="profileData"
    [partnerAdresses]="partnerAdresses"
    [partnerBankAccounts]="partnerBankAccounts"
    [requestTypes]="requestTypes"
    [readOnly]="readOnly"
  >
  </my-user-profile>
</ng-container>
        
<ng-container *ngIf="isAdmin && dataLoaded">
  <profile-general-view 
    [profileData]="profileData"
    [readOnly]="readOnly"
  >
  </profile-general-view>
</ng-container>